import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Импортируем из shared (общий код для web и mobile)
import en from 'shared/locales/en.json';

// Получаем начальный язык: приоритет ?lang= в URL (для краулеров и шаринга), затем localStorage, затем en
const getInitialLanguage = () => {
  if (typeof window !== 'undefined' && window.location?.search) {
    const lang = new URLSearchParams(window.location.search).get('lang');
    if (lang === 'en' || lang === 'ru') return lang;
  }
  return localStorage.getItem('language') || 'en';
};

const initialLng = getInitialLanguage();

// Начальные ресурсы - всегда включаем английский как fallback
const resources = {
  en: {
    translation: en,
  },
};

// Если начальный язык русский, загружаем его динамически
if (initialLng === 'ru') {
  // Загружаем русский асинхронно после инициализации
  import('shared/locales/ru.json').then(ru => {
    i18n.addResourceBundle('ru', 'translation', ru.default, true, true);
    // Переключаемся на русский после загрузки
    i18n.changeLanguage('ru');
  }).catch(error => {
    console.error('Failed to load Russian translations:', error);
    // Остаемся на английском при ошибке
  });
}

// Инициализация i18n
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng === 'ru' ? 'en' : initialLng, // Временно на английском, если русский еще не загружен
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
    returnObjects: false,
    debug: false,
  });

// Функция для динамической загрузки переводов
const loadTranslation = async (lng) => {
  if (i18n.hasResourceBundle(lng, 'translation')) {
    return; // Уже загружен
  }
  
  try {
    if (lng === 'ru') {
      const ru = await import('shared/locales/ru.json');
      i18n.addResourceBundle('ru', 'translation', ru.default, true, true);
    }
    // Английский уже загружен синхронно
  } catch (error) {
    console.error(`Failed to load translations for ${lng}:`, error);
  }
};

// Обработчик смены языка - загружаем новый язык динамически
i18n.on('languageChanged', (lng) => {
  loadTranslation(lng);
});

export default i18n;